
import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";

@Component({
    components: {},
})
export default class AccessDenied extends Vue {
    @Prop({ default: "mdi-alert", type: String })
    icon!: string;

    @Prop()
    header!: string;

    @Prop()
    message!: string;
}
